/** 年齢レイティング */

import styles from "./index.module.scss"
import { RatingViewModel } from "./RatingViewModel"

export type Props = {
  ageRatings: RatingViewModel[]
  selectedAgeId: string
  onChange: (v: RatingViewModel) => void
}

const AgeRating: React.FC<Props> = ({
  ageRatings,
  selectedAgeId,
  onChange,
}) => {
  const onSelect = (id: string) => {
    const rating = ageRatings.find((r) => r.id === id)
    if (rating) {
      onChange(rating)
    }
  }

  return (
    <>
      <ul className={styles.AgeList}>
        {ageRatings.map((ageRating) => (
          <li className={styles.AgeListItem} key={ageRating.id}>
            <label className={styles.Radio}>
              <input
                className={styles.Radio_input}
                type="radio"
                name="age_rating_id"
                value={ageRating.id}
                checked={ageRating.id === selectedAgeId}
                onChange={(ev) => onSelect(ev.currentTarget.value)}
              />
              <span className={styles.Radio_label}>{ageRating.label}</span>
            </label>
          </li>
        ))}
      </ul>
    </>
  )
}
export default AgeRating
